import { render } from "./Compass.vue?vue&type=template&id=9cc5ce40"
import script from "./Compass.vue?vue&type=script&lang=js"
export * from "./Compass.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__